/* eslint-disable @typescript-eslint/no-var-requires, global-require */

import {isArray, memoize} from 'lodash';

interface DjangoJSI18N {
    catalog: Record<string, string | string[]>;
}

const getJSI18N = memoize((formattedLanguages: string) => {
    const languages = formattedLanguages
        .toLowerCase()
        .split(',')
        .map(language => language.split(';')[0]);

    let jsi18n: DjangoJSI18N | undefined;
    for (const language of languages) {
        try {
            jsi18n = require(process.env.DJANGO_JSI18N_PATH + '/' + language + '/djangojs.json');
            break;
        } catch {
            continue;
        }
    }

    return jsi18n;
});

export default function gettext(languages: string, input: string) {
    const jsi18n = getJSI18N(languages);
    const output = jsi18n && jsi18n.catalog[input];

    if (!output) {
        return input;
    } else if (isArray(output)) {
        return output[0];
    } else {
        return output;
    }
}
